import { theme } from "antd";
import React from "react";
import Profile from "../Components/Settings/Profile";
import Appearance from "../Components/Settings/Appearance";
import "../Components/matter/LabPreview.css";

function Settings() {
  const { token } = theme.useToken();

  return (
    <div className="lab-page settings-page" style={{ "--lab-surface": token.colorBgContainer, "--note-accent": token.colorPrimary }}>
      <div className="note-top-head settings-head">
        <div>
          <h2 className="settings-title">ڕێخستن</h2>
          <p className="note-top-sub">زانیاری ئەکاونت و ڕووکار</p>
        </div>
      </div>
      <div className="settings-layout">
        <Profile />
        <Appearance />
      </div>
    </div>
  );
}

export default Settings;
